import React, { useState } from 'react'
import AddDetails from '../verifyVendorDetails/AddDetails'
import StudentMappedDetailsPage from '../paymentDetails/StudentMappedDetailsPage'
import Footer from "modules/studentRefund/completionRefund/reinitiate/components/Footer";
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { useWizard } from 'components/wizard/WizardContext';
import { createVendorRequestPayload } from '../helper';
import ApprovalSentSuccessDialog from 'views/pages/manage/unAssigned/examCharges/examChargesDetails/dialogs/ApprovalSentSuccessDialog';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from 'views/pages/manage/common/constant';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { useHistory } from 'react-router-dom';

const ReviewStep = () => {
    const history = useHistory();
    const { values, updateValues, dropdowns, next } = useWizard();
    const [isloading, setIsLoading] = useState(false);
    const [approvalActionSuccessDialogOpen, setApprovalActionSuccessDialogOpen] = useState(false);
    const [approvalActionSuccessDialogInfo, setApprovalActionSuccessDialogInfo] = useState({});

    const proceedNext = async () => {
        try {
            setIsLoading(true);
            const reqObj = createVendorRequestPayload(values);
            const resp = await fetchAllPostPromisedData(
                `${endpoint?.raiseVendorRequest?.admissionAdvisor?.create}`,
                { ...reqObj },
                "post",
            );
            if (resp?.code === 200) {
                const transactionList = resp?.data?.transactionids;

                if (transactionList?.length > 0) {
                    const formattedIds = transactionList
                        .map(id => `#${id}`)
                        .join(", ");

                    setApprovalActionSuccessDialogInfo({
                        heading: "Vendor payment request has been sent for approval",
                        subHeading: `Payment order IDs (${formattedIds}) has been generated and sent for further approvals`
                    });

                    setApprovalActionSuccessDialogOpen(true);
                }
            } else {
                debugger

                // resp?.message?failureToast(resp?.message):failureToast("Payment request submission failed as the system could not generate the Payment Order ID. <br/> No request has been created. Please re-submit.")
            }

        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);

        }
    }

    return (
        <div style={{ paddingBottom: "120px" }}>

            <AddDetails
                isShowFooter={false}
                readOnly={true}
            />


            <StudentMappedDetailsPage
                isShowFooter={false}
                readOnly={true}
            />

            <ApprovalSentSuccessDialog
                open={approvalActionSuccessDialogOpen}
                setOpen={setApprovalActionSuccessDialogOpen}
                heading={approvalActionSuccessDialogInfo?.heading}
                subHeading={approvalActionSuccessDialogInfo?.subHeading}
                buttonLabel={"Approval dashboard"}
                buttonStyle={{ width: "51%" }}
                closeCb={() => {
                    history.push('/admin/vendorSetup/paymentApprovals')
                }} />

            <Footer>
                <div>Verify & send for approval</div>
                <AButton
                    // disabled={() => { }}
                    onClick={proceedNext}
                    className="button_remove_left_margin"
                    variant="primary_filled"
                >
                    Send for approval
                </AButton>
            </Footer>

        </div>
    )
}

export default ReviewStep